import { useContext } from 'react';

import { LoadingContext } from './context';

export const useIsLoading = () => useContext(LoadingContext);
